import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
} from "components/detail";

export const ChildShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    아이 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    아이 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="생일" value={record?.birthDate} />
                        <FieldItem label="승인여부" value={record?.approval} />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=CHILD`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
